import {
  AI_NAPPING_REASON,
  aiQuickResponseSchema,
  type AiQuickResponse,
  type AiQuickTask,
} from '@awwyeah/shared';

/**
 * Client half of `/api/ai`. Two error shapes, and the distinction is the whole point:
 * `AssistantNappingError` is not a failure anybody should apologise for, it's the LLM
 * being down, and the UI answers it with a quiet note (docs/AI-PIPELINE.md).
 */

export class AssistantNappingError extends Error {
  constructor() {
    super(AI_NAPPING_REASON);
    this.name = 'AssistantNappingError';
  }
}

export class AiRequestError extends Error {}

export async function postAiQuick(
  task: AiQuickTask,
  text: string,
  context?: Record<string, unknown>,
): Promise<AiQuickResponse> {
  let response: Response;
  try {
    response = await fetch('/api/ai/quick', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ task, text, ...(context ? { context } : {}) }),
    });
  } catch {
    // Device offline: failure mode 1. Also a nap as far as the UI is concerned.
    throw new AssistantNappingError();
  }

  if (response.status === 503) throw new AssistantNappingError();
  if (!response.ok) throw new AiRequestError(`ai_quick_failed_${response.status}`);

  const parsed = aiQuickResponseSchema.safeParse(await response.json().catch(() => null));
  if (!parsed.success) throw new AiRequestError('unexpected_response');
  return parsed.data;
}
